export default __webpack_public_path__ + "static/media/company_5.a1f6fb42.jpg";